import api from "../config/api";
import { getErrorMessage } from "../config/errorHelper";

// ─────────────────────────────────────────────
//  FACTURATION — vue admin (toute entreprise) + édition + allocation manuelle
// ─────────────────────────────────────────────

export const getContractsForCompany = async (companyId) => {
  try {
    return (await api.get(`/billing/admin/company/${companyId}`)).data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getContractEntriesAdmin = async (contractId, from, to) => {
  try {
    const params = {};
    if (from) params.from = from;
    if (to)   params.to   = to;
    return (await api.get(`/billing/admin/contracts/${contractId}/entries`, { params })).data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

/**
 * Édite un contrat existant (nom, dates, quota d'heures, reconduction, période).
 * Seuls les champs fournis dans payload sont modifiés.
 */
export const updateContract = async (contractId, payload) => {
  try {
    const res = await api.put(`/billing/admin/contracts/${contractId}`, payload);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (error) {
    if (!(error.response || error.request)) throw error;
    throw new Error(getErrorMessage(error));
  }
};

/**
 * Crée un nouveau contrat pour une entreprise.
 * payload : { companyId, name, type, startDate, endDate, totalHoursAllocated,
 *             rolloverEnabled, billingPeriod, hourlyRate }
 */
export const createContract = async (payload) => {
  try {
    const res = await api.post(`/billing/admin/contracts`, payload);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (error) {
    if (!(error.response || error.request)) throw error;
    throw new Error(getErrorMessage(error));
  }
};

/** Supprime un contrat ainsi que tout son historique d'heures. */
export const deleteContract = async (contractId) => {
  try {
    const res = await api.delete(`/billing/admin/contracts/${contractId}`);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (error) {
    if (!(error.response || error.request)) throw error;
    throw new Error(getErrorMessage(error));
  }
};

export const addManualEntry = async (contractId, payload) => {
  try {
    const res = await api.post(`/billing/admin/contracts/${contractId}/entries`, payload);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (error) {
    if (!(error.response || error.request)) throw error;
    throw new Error(getErrorMessage(error));
  }
};

export const deleteManualEntry = async (entryId) => {
  try {
    const res = await api.delete(`/billing/admin/entries/${entryId}`);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

// ─────────────────────────────────────────────
//  FACTURATION EN UN CLIC DEPUIS UN TICKET
//  Bouton "Facturer ce ticket" — TicketDetailPage.jsx (admin).
//  Ajouté le 28/09/2026.
// ─────────────────────────────────────────────

/**
 * Facture un ticket en un clic. payload : { contractId, hours, description? }
 * hours est saisi positif (heures travaillées) — la conversion en
 * consommation négative se fait côté backend.
 */
export const billTicket = async (ticketId, payload) => {
  try {
    const res = await api.post(`/billing/admin/tickets/${ticketId}/bill`, payload);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (error) {
    if (!(error.response || error.request)) throw error;
    throw new Error(getErrorMessage(error));
  }
};

/** Statut de facturation d'un ticket — data === null si pas encore facturé. */
export const getTicketBillingStatus = async (ticketId) => {
  try {
    return (await api.get(`/billing/admin/tickets/${ticketId}/billing-status`)).data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};